import React from "react";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FixedSizeList as List } from "react-window";
import { KAvatar } from "@kyburz/kdesign-system";
import SelectDropDown from "../SelectDropDown";
import { DropDownType } from "../../interfaces/DropDownInterface";
import { UserInterface } from "../../interfaces/UserInterface";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    border: "1px solid #e2e2e2",
    width: "100%",
    borderRadius: 4,
    marginTop: 8,
  },
  row: {
    height: "40px",
    width: "240px",
    padding: "10px 16px 10px 16px",
    display: "flex",
    lineHeight: 1,
    color: "#383F51",
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  active: {
    color: "#2F80ED",
    fontWeight: 500,
  },
  avatar: {
    marginTop: -3,
    marginRight: 8,
  },
  permissions: {
    alignSelf: "center",
    marginRight: 8,
    cursor: "pointer",
    position: "absolute",
    right: 0,
    display: "flex",
  },
  permissionsText: {
    fontSize: 12,
    alignSelf: "center",
    marginRight: 8,
  },
}));
interface Props {
  elements: any;
  data?: any;
  height?: number;
  width?: number | "auto";
  dropDownItems: DropDownType[];
  setSelectedUserId: (id: number) => void;
  setSelectedUsers: (value: UserInterface, checkbox: string) => void;
}

const KList = ({
  elements = [],
  data = [],
  height = 425,
  width = 240,
  dropDownItems,
  setSelectedUserId,
  setSelectedUsers,
}: Props) => {
  const classes = useStyle();

  const handleRowClick = (index: number): void => {
    setSelectedUserId(data[index].user_id);
  };

  const handleDisplayValues = (index: number): string => {
    const values: string[] = [];

    if (data[index].edit_vehicle) {
      values.push("Edit");
    }
    if (data[index].create_reservation) {
      values.push("Reserve");
    }
    if (!data[index].edit_vehicle && !data[index].create_reservation) {
      values.push("View Only");
    }
    return values.join(", ");
  };

  const Row = ({ index, style }) => (
    <div
      className={classes.row}
      onClick={() => handleRowClick(index)}
      style={style}
    >
      <div className={classes.avatar}>
        <KAvatar
          firstName={data[index]?.first_name || ""}
          lastName={data[index]?.last_name || ""}
          avatar={data[index]?.avatar || null}
          size={20}
        />
      </div>
      {elements[index]}
      <div className={classes.permissions}>
        <div className={classes.permissionsText}>
          {handleDisplayValues(index)}
        </div>
        <SelectDropDown
          icon="more-vertical"
          menuItems={dropDownItems}
          setSelectedUsers={setSelectedUsers}
          currentItem={data[index]}
        />
      </div>
    </div>
  );
  return (
    <div className={classes.root}>
      <List
        height={height}
        itemCount={elements.length}
        itemSize={35}
        width={width}
      >
        {Row}
      </List>
    </div>
  );
};

export default KList;
